import { findFromTuple } from "../../lib/find-from-tupple";

export type GlobalNotificationLinkType = 'info'

export const GlobalNotificationLinkTypes = [
  ['info', 'お知らせ']
] as const

export const globalNotificationLinkTypeString = (type: GlobalNotificationLinkType) => findFromTuple(type, GlobalNotificationLinkTypes)[1]
